<template>
  <thead>
    <tr>
      <th
        v-for="(name, index) in headers"
        :key="index"
        class="px-6 align-middle border border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left"
        :class="[
          color === 'light'
            ? 'bg-blueGray-50 text-blueGray-500 border-blueGray-100'
            : 'bg-emerald-800 text-emerald-300 border-emerald-700'
        ]"
      >
        {{ name }}
      </th>
      <th
        class="px-6 align-middle border border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left"
        :class="[
          color === 'light'
            ? 'bg-blueGray-50 text-blueGray-500 border-blueGray-100'
            : 'bg-emerald-800 text-emerald-300 border-emerald-700'
        ]"
      ></th>
    </tr>
  </thead>
</template>

<script>
export default {
  name: "TableHead",
  props: {
    color: {
      default: "light",
      validator(value) {
        // The value must match one of these strings
        return ["light", "dark"].indexOf(value) !== -1;
      }
    },
    headers: {
      type: Array,
      required: true
    }
  }
};
</script>
